import { render, staticRenderFns } from "./AutopaySetup.vue?vue&type=template&id=3a858134&scoped=true&"
import script from "./AutopaySetup.vue?vue&type=script&lang=js&"
export * from "./AutopaySetup.vue?vue&type=script&lang=js&"
import style0 from "./AutopaySetup.vue?vue&type=style&index=0&id=3a858134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a858134",
  null
  
)

export default component.exports